<template>
  <div class="mod-notice">
    <div class="page-header">
      <span class="page-header__title">公告管理</span>
    </div>

    <div class="page-body">
      <!-- 筛选栏 -->
      <div class="toolbar">
        <el-select
          v-model="filterType"
          placeholder="全部类型"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div class="toolbar__right">
          <el-button type="primary" icon="el-icon-plus" @click="openDialog()">新增公告</el-button>
        </div>
      </div>

      <!-- 公告列表 -->
      <div class="panel">
        <el-table :data="dataList" v-loading="loading" style="width: 100%;">
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.type === noticeType.MARQUEE ? '' : 'warning'" size="small">
                {{ typeLabel(scope.row.type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="90">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.imgUrl"
                :src="scope.row.imgUrl"
                fit="cover"
                class="notice-img"
                :preview-src-list="[scope.row.imgUrl]">
              </el-image>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="内容" min-width="280" show-overflow-tooltip></el-table-column>
          <el-table-column label="跳转链接" min-width="150">
            <template slot-scope="scope">
              <a v-if="scope.row.linkUrl" :href="scope.row.linkUrl" target="_blank" class="link">
                {{ scope.row.linkUrl }}
              </a>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期" width="230">
            <template slot-scope="scope">{{ validPeriod(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="90"></el-table-column>
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <el-tag :type="isEnabled(scope.row) ? 'success' : 'info'" size="small">
                {{ isEnabled(scope.row) ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="170" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDialog(scope.row)">编辑</el-button>
              <el-button
                type="text"
                size="small"
                :class="isEnabled(scope.row) ? 'danger-text' : ''"
                @click="handleToggle(scope.row)">
                {{ isEnabled(scope.row) ? '禁用' : '启用' }}
              </el-button>
              <el-button type="text" size="small" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗：新增 / 编辑公告 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dataForm.id ? '编辑公告' : '新增公告'"
      width="600px"
      :close-on-click-modal="false">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-position="top">
        <el-form-item label="类型" prop="type">
          <el-select v-model="dataForm.type" placeholder="请选择类型" style="width: 100%;">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            v-model="dataForm.content"
            type="textarea"
            :rows="4"
            placeholder="公告内容">
          </el-input>
        </el-form-item>
        <!-- 图片只对弹窗类型有意义 -->
        <el-form-item v-if="dataForm.type === noticeType.POPUP" label="弹窗图片">
          <div class="notice-upload">
            <el-upload
              :action="uploadUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              accept="image/*"
              :before-upload="handleBeforeUpload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError">
              <el-image
                v-if="previewUrl"
                :src="previewUrl"
                fit="cover"
                class="notice-upload__preview">
              </el-image>
              <div v-else class="notice-upload__empty">
                <i :class="uploading ? 'el-icon-loading' : 'el-icon-plus'"></i>
              </div>
            </el-upload>
            <div class="notice-upload__actions">
              <div class="form-tip">支持 jpg / png / gif / webp，不超过 5MB</div>
              <el-button v-if="previewUrl" type="text" class="danger-text" @click="handleRemoveImage">移除图片</el-button>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="跳转链接" prop="linkUrl">
          <el-input v-model="dataForm.linkUrl" placeholder="可选，最长 200 字符" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 100%;">
          </el-date-picker>
          <div class="form-tip">留空表示长期有效</div>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="dataForm.sort"
                :min="dataForm.id ? 0 : 1"
                :max="999999"
                style="width: 100%;">
              </el-input-number>
              <div class="form-tip">数值大的排在前面</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="dataForm.status">
                <el-radio :label="noticeStatus.ENABLED">启用</el-radio>
                <el-radio :label="noticeStatus.DISABLED">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button type="primary" :loading="submitting" @click="handleSubmit">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  listNotice,
  addNotice,
  updateNotice,
  updateNoticeStatus,
  deleteNotice,
  NOTICE_TYPE,
  NOTICE_TYPE_OPTIONS,
  NOTICE_STATUS,
  OSS_UPLOAD_URL,
  OSS_UPLOAD_SUCCESS_CODE,
  ossUploadHeaders
} from '@/api/notice'

// 图片大小上限
const MAX_IMAGE_SIZE_MB = 5

export default {
  name: 'Notice',
  data () {
    return {
      loading: false,
      submitting: false,
      filterType: '',
      rawList: [],
      page: 1,
      limit: 10,
      total: 0,
      dialogVisible: false,
      dateRange: null,
      // 图片上传：imgFile 存 OSS 对象键用于提交，previewUrl 仅用于回显
      uploading: false,
      previewUrl: '',
      dataForm: {
        id: '',
        type: NOTICE_TYPE.MARQUEE,
        content: '',
        imgFile: '',
        linkUrl: '',
        sort: 100,
        status: NOTICE_STATUS.ENABLED
      }
    }
  },

  computed: {
    noticeType () {
      return NOTICE_TYPE
    },
    noticeStatus () {
      return NOTICE_STATUS
    },
    typeOptions () {
      return NOTICE_TYPE_OPTIONS
    },
    uploadUrl () {
      return OSS_UPLOAD_URL
    },
    uploadHeaders () {
      return ossUploadHeaders()
    },
    dataList () {
      return this.rawList
    },
    dataRule () {
      return {
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        content: [
          { required: true, message: '公告内容不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请填写排序', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },

  created () {
    this.loadList()
  },

  methods: {
    loadList () {
      this.loading = true
      return listNotice({
        page: this.page,
        limit: this.limit,
        type: this.filterType
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          this.rawList = []
          this.total = 0
          return this.$message.error(res.msg)
        }
        this.rawList = (res.data && res.data.list) || []
        this.total = (res.data && res.data.total) || 0
      }).catch(() => {
        this.$message.error('加载公告失败')
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch () {
      this.page = 1
      this.loadList()
    },

    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.loadList()
    },

    // ---------- 图片上传 ----------
    handleBeforeUpload (file) {
      if (!file.type.startsWith('image/')) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (file.size / 1024 / 1024 > MAX_IMAGE_SIZE_MB) {
        this.$message.error(`图片不能超过 ${MAX_IMAGE_SIZE_MB}MB`)
        return false
      }
      this.uploading = true
      return true
    },

    // 该上传接口成功码是 200，与项目其它接口的 0 不同
    handleUploadSuccess (res) {
      this.uploading = false
      if (res.code !== OSS_UPLOAD_SUCCESS_CODE) {
        return this.$message.error(res.msg || '上传失败')
      }
      // img_file 存 OSS 对象键，url 仅用于回显
      this.dataForm.imgFile = res.data.fileName || ''
      this.previewUrl = res.data.url || ''
      this.$message.success('上传成功')
    },

    handleUploadError () {
      this.uploading = false
      this.$message.error('上传失败，请重试')
    },

    handleRemoveImage () {
      this.dataForm.imgFile = ''
      this.previewUrl = ''
    },

    handlePageChange (val) {
      this.page = val
      this.loadList()
    },

    openDialog (row) {
      this.dialogVisible = true
      this.uploading = false
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
        if (row) {
          this.dataForm = {
            id: row.id,
            type: row.type,
            content: row.content,
            imgFile: row.imgFile || '',
            linkUrl: row.linkUrl || '',
            sort: Number(row.sort) || 0,
            status: row.status
          }
          this.previewUrl = row.imgUrl || ''
          this.dateRange = row.startTime && row.endTime ? [row.startTime, row.endTime] : null
        } else {
          this.dataForm = {
            id: '',
            type: NOTICE_TYPE.MARQUEE,
            content: '',
            imgFile: '',
            linkUrl: '',
            sort: 100,
            status: NOTICE_STATUS.ENABLED
          }
          this.previewUrl = ''
          this.dateRange = null
        }
      })
    },

    handleSubmit () {
      this.$refs.dataForm.validate(valid => {
        if (!valid) {
          return false
        }
        const payload = {
          ...this.dataForm,
          // 图片只对弹窗类型有效，跑马灯不带图
          imgFile: this.dataForm.type === NOTICE_TYPE.POPUP ? this.dataForm.imgFile : '',
          startTime: this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : '',
          endTime: this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : ''
        }
        this.submitting = true
        const request = payload.id ? updateNotice(payload) : addNotice(payload)
        request.then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success(this.$t('prompt.success'))
          this.dialogVisible = false
          this.loadList()
        }).catch(() => {
          this.$message.error('保存失败')
        }).finally(() => {
          this.submitting = false
        })
      })
    },

    handleToggle (row) {
      const enabled = this.isEnabled(row)
      const nextStatus = enabled ? NOTICE_STATUS.DISABLED : NOTICE_STATUS.ENABLED
      updateNoticeStatus(row.id, nextStatus).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success(enabled ? '已禁用' : '已启用')
        this.loadList()
      }).catch(() => {
        this.$message.error('操作失败')
      })
    },

    handleDelete (row) {
      this.$confirm('确定删除这条公告？', '提示', {
        type: 'warning'
      }).then(() => {
        return deleteNotice(row.id)
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return Promise.reject(new Error(res.msg || '删除失败'))
        }
        this.$message.success('删除成功')
        // 删掉当前页最后一条时回退一页
        if (this.rawList.length === 1 && this.page > 1) {
          this.page -= 1
        }
        this.loadList()
      }).catch(e => {
        if (e && e.message) {
          this.$message.error(e.message)
        }
      })
    },

    isEnabled (row) {
      return row.status === NOTICE_STATUS.ENABLED
    },

    typeLabel (type) {
      const target = NOTICE_TYPE_OPTIONS.find(item => item.value === type)
      return target ? target.label : '-'
    },

    validPeriod (row) {
      if (!row.startTime && !row.endTime) {
        return '长期有效'
      }
      return `${row.startTime || '不限'} ~ ${row.endTime || '不限'}`
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-notice {
  background-color: #f5f7fa;
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}

.page-body {
  padding: 16px;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &__select {
    width: 160px;
  }

  &__tip {
    margin-left: 8px;
    color: #e6a23c;
    font-size: 16px;
  }

  &__right {
    margin-left: auto;
  }
}

.panel {
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 0 16px 16px;
}

.link {
  color: #409eff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.danger-text {
  color: #f56c6c;
}

.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
}

.notice-img {
  width: 56px;
  height: 36px;
  border-radius: 3px;
}

.notice-upload {
  display: flex;
  align-items: flex-end;

  &__preview {
    width: 148px;
    height: 92px;
    border-radius: 4px;
    display: block;
  }

  &__empty {
    width: 148px;
    height: 92px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #c0c4cc;
    font-size: 22px;
    transition: border-color .2s;

    &:hover {
      border-color: #409eff;
    }
  }

  &__actions {
    margin-left: 16px;

    .form-tip {
      margin-top: 0;
    }
  }
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

::v-deep .el-table th {
  background-color: #fafbfc;
  color: #909399;
  font-weight: 500;
}
</style>
